import React from "react";
import Sidebar from "./Component/Sidebar";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";

const AdminLayout = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 , marginTop: '30px' }}>
        <Outlet /> 
      </Box>
    </Box>
  );
};

export default AdminLayout;
